import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Accounts from '../../components/admin/accounts';

import { backToAccountManagement } from '../../actions/adminActions';

class AccountManagement extends Component {
  static propTypes = {
    children: PropTypes.node,
    backToAccountManagement: PropTypes.func,
  }

  state = {

  }

  UNSAFE_componentWillMount() {
    this.props.backToAccountManagement();
  }

  render() {
    const { children } = this.props;
    if (children) {
      return (
        <div>
          { children }
        </div>
      );
    }
    return (
      <div className="admin-body usersearch-body">
        <Accounts />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    backToAccountManagement: bindActionCreators(backToAccountManagement, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(AccountManagement);

